import { api } from '../../base';
import { IScheduleInterviewApiPayload } from '../../common';
import {
    IApplyToJobPayload,
    ISetTagAction,
    IUpdateJobApplicationStatusAction,
    IUpdateUserRequirementScoreAction,
} from '../jobApplication/redux';

export const applyToJobApi = (formData: IApplyToJobPayload, jobId: number) => {
    const data = new FormData();
    if (formData.resume.file) {
        data.append(
            'resume.file',
            formData.resume.file,
            formData.resume.file.name
        );
    }
    data.append('first_name', formData.first_name);
    data.append('last_name', formData.last_name);
    if (formData.phone) {
        data.append('phone', formData.phone);
    }
    data.append('email', formData.email);
    data.append(
        'resume.accepted_terms',
        formData.resume.accepted_terms.toString()
    );

    if (formData.ref) {
        data.append('ref', formData.ref);
    }
    if (formData.notes) {
        data.append('notes', formData.notes);
    }

    if (formData.referrer) {
        data.append('referrer.first_name', formData.referrer.first_name);
        data.append('referrer.last_name', formData.referrer.last_name);
        data.append('referrer.email', formData.referrer.email);
        data.append('referrer.phone', formData.referrer.phone);
        data.append('referrer.company_name', formData.referrer.company_name);
        data.append(
            'referrer.is_point_of_contact',
            formData.referrer.is_point_of_contact.toString()
        );
    }

    if (formData.question_answers && formData.question_answers.length > 0) {
        const questionAnswersJson = formData.question_answers.map(
            (qa, index) => {
                const item: Record<string, unknown> = {
                    apply_question: qa.apply_question,
                };
                if (qa.answer !== undefined) {
                    item.answer = qa.answer;
                }
                if (
                    qa.selected_option_values &&
                    qa.selected_option_values.length > 0
                ) {
                    item.selected_option_values = qa.selected_option_values;
                }
                if (qa.file) {
                    item.file = `question_file_${index}`;
                }
                return item;
            }
        );

        data.append('question_answers', JSON.stringify(questionAnswersJson));

        formData.question_answers.forEach((qa, index) => {
            if (qa.file) {
                data.append(`question_file_${index}`, qa.file, qa.file.name);
            }
        });
    }

    return api.post({
        url: `candidatejobs/${jobId}/apply/`,
        queryParams: {
            ck: formData.company_key,
        },
        data,
        config: {
            headers: { 'Content-Type': 'multipart/form-data' },
        },
    });
};

export const fetchJobApplication = (jobApplicationId: string) => {
    return api.get({ url: `job-applications/${jobApplicationId}` });
};

export const updateJobApplicationStatusApi = (
    payload: IUpdateJobApplicationStatusAction
) => {
    return api.patch({
        url: `steps/${payload.stepId}/change_status/`,
        data: {
            status: payload.status,
            text: payload.updateText ?? undefined,
            reject_reason: Number(payload.reasonOption?.value) ?? undefined,
            application_status: payload.applicationStatus ?? undefined,
        },
    });
};

export const fetchJobApplicationsStatisticsApi = () => {
    return api.get({ url: `job-applications/statistics/` });
};

export const createJobApplicationComment = (
    jobApplicationId: number,
    text: string
) => {
    return api.patch({
        url: `job-applications/${jobApplicationId}/save_comment/`,
        data: { text },
    });
};

export const sendChatMessage = (jobApplicationId: number, message: string) => {
    return api.post({
        url: `job-applications/${jobApplicationId}/send_message/`,
        data: { message },
    });
};

export const saveforlaterJobApplication = (
    jobApplicationId: number,
    deleteSave?: boolean
) => {
    if (deleteSave) {
        return api.delete({
            url: `job-applications/${jobApplicationId}/saveforlater/`,
        });
    }
    return api.post({
        url: `job-applications/${jobApplicationId}/saveforlater/`,
    });
};

export const applyTag = (payload: ISetTagAction) => {
    return api.post({
        url: `related-tags/`,
        data: payload,
    });
};

export const deleteTag = (id: number) => {
    return api.delete({
        url: `related-tags/${id}`,
    });
};

export const updateUserRequirementScore = (
    payload: IUpdateUserRequirementScoreAction
) => {
    return api.post({
        url: `job-application-user-requirement-scores/`,
        data: payload,
    });
};

export const duplicateJobApplicationApi = (
    applicationId: number,
    jobId: number
) => {
    return api.post({
        url: `job-applications/${applicationId}/duplicate_application/`,
        data: { job_id: jobId },
    });
};

export const scheduleInterviewApi = (
    jobApplicationId: number,
    data: IScheduleInterviewApiPayload
) => {
    return api.post({
        url: `job-applications/${jobApplicationId}/schedule_interview/`,
        data,
    });
};

export const updateCandidateInfoApi = (
    jobApplicationId: number,
    data: {
        first_name: string;
        last_name: string;
        phone: string;
        email: string;
    }
) => {
    return api.patch({
        url: `job-applications/${jobApplicationId}/`,
        data,
    });
};

export const batchDeclineCandidatesApi = (data: {
    job_application_ids: Array<number>;
    reject_reason?: number;
    text?: string;
}) => {
    return api.post({
        url: `job-applications/batch_decline/`,
        data,
    });
};
